import * as React from "react"

/**
 * The sidebar's context, split out from sidebar.tsx.
 *
 * Only so it can be imported without it. sidebar.tsx pulls in Radix — Sheet,
 * Tooltip, Slot — which does not survive happy-dom, so anything importing it
 * could only ever be tested by reading its source. That is the weaker kind of
 * test and it is what let a crash through once already.
 *
 * With the context here, a consumer like useCompactSidebar can be rendered
 * against a hand-rolled provider in a real test, effect and all.
 */
export type SidebarContextProps = {
  state: "expanded" | "collapsed"
  open: boolean
  setOpen: (open: boolean) => void
  /**
   * Change the sidebar without remembering it.
   *
   * setOpen persists to a 7-day, path=/ cookie, which is right for a choice the
   * user made and wrong for one a single page made on their behalf: collapsing
   * the rail for a dashboard left every other page collapsed for a week. This
   * setter moves the sidebar for as long as you are here and leaves the
   * remembered preference alone.
   */
  setOpenTransient: (open: boolean) => void
  openMobile: boolean
  setOpenMobile: (open: boolean) => void
  isMobile: boolean
  toggleSidebar: () => void
}

export const SidebarContext = React.createContext<SidebarContextProps | null>(null)
